import React, { useEffect } from "react";
import useCalendlyScript from "../../source/hooks/useCalendlyScript";
import Button from "components/core/Button/Button";
import styles from "./CalendlyEmbed.module.scss";

interface CalendlyEmbedProps {
  url: string;
}

const CalendlyEmbed: React.FC<CalendlyEmbedProps> = ({ url }) => {
  useCalendlyScript();

  const openPopup = () => {
    (window as any).Calendly.initPopupWidget({ url: url });
  };

  useEffect(() => {
    return () => {
      (window as any).Calendly.closePopupWidget();
    };
  }, []);
  return (
    <Button
      className={styles.CalendlyEmbed}
      onClick={openPopup}
      type="primary"
      size="large"
    >
      Schedule a Call
    </Button>
  );
};

export default CalendlyEmbed;
